var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import cookie from '../../cookie/cookie';
import request from '../../utils/request';
import { mapState } from 'vuex';
export default Vue.extend({
    data: function () {
        var _this = this;
        var checkPwd = function (rule, value, callback) {
            if (!value) {
                return callback(new Error(rule.message));
            }
            else if (value &&
                _this.editForm[rule.name] &&
                value !== _this.editForm[rule.name]) {
                return callback(new Error('两次密码输入不一致'));
            }
            else {
                callback();
            }
        };
        return {
            isShowEdit: false,
            basic: [
                {
                    key: '用户名',
                    val: '',
                },
                {
                    key: '角色',
                    val: '超级管理员',
                },
                {
                    key: '昵称',
                    val: '',
                },
                {
                    key: '密码',
                    val: '******',
                    ope: '修改',
                },
            ],
            editForm: {
                password: '',
                new_password: '',
                surenew_password: '',
                username: '',
            },
            editRule: {
                password: [
                    { required: true, message: '请输入原始密码', trigger: 'blur' },
                ],
                new_password: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { validator: checkPwd, trigger: 'blur', name: 'surenew_password' },
                ],
                surenew_password: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: checkPwd, trigger: 'blur', name: 'new_password' },
                ],
            },
        };
    },
    created: function () {
        this.getAccoutInfo();
    },
    computed: __assign({ username: function () {
            return cookie.getCookie('usernameZh');
        },
        userId: function () {
            return cookie.getCookie('dafs_user_id');
        } }, mapState('auth', {
        accountDetail: 'accountDetail',
    })),
    methods: {
        getUserName: function () {
            this.name = cookie.getCookie('usernameZh');
        },
        getFocus: function () {
            this.isShowEdit = true;
            // this.$refs['origin'].focus()
        },
        savePwd: function () {
            var _this = this;
            this.$refs['editForm'].validate(function (valid) {
                if (!valid)
                    return;
                // const editForm = this.editForm
                // editForm.username = this.username
                var _a = _this.editForm, password = _a.password, new_password = _a.new_password;
                var data = Object.assign({}, {
                    password_type: 1,
                    password: password,
                    new_password: new_password,
                });
                request({
                    method: 'post',
                    url: '/proxy/19pay/merchant/passport/auth/password/change',
                    data: data,
                }).then(function (res) {
                    if (!res)
                        return;
                    if (!res.errorCode) {
                        _this.$message({
                            message: '修改密码成功',
                            type: 'success',
                        });
                        _this.isShowEdit = false;
                    }
                    else {
                        _this.$message.error(res.errorMsg);
                    }
                    _this.editForm = {
                        password: '',
                        new_password: '',
                        surenew_password: '',
                        username: _this.username,
                    };
                });
            });
        },
        getAccoutInfo: function () {
            this.$store.dispatch('auth/GET_USER_INFO');
        },
    },
});
